import React, { Component } from "react";
import { Link } from "react-router-dom";

export class Admin extends Component<{}, {}> {
  render() {
    return (
      <div>
        <Link className="btn btn-success d-block mb-3" to="admin/create">
          Start mission!
        </Link>
        {/* <Link className="btn btn-success d-block mb-3" to="admin/invite">
          Invite people
        </Link> */}
        <Link className="btn btn-success d-block mb-3" to="admin/users/all">
          List of all testers
        </Link>
        {/* <Link className="btn btn-success d-block mb-3" to="admin/users/invited">
          List of invited testers
        </Link> */}
        <Link className="btn btn-success d-block mb-3" to="admin/users/active">
          List of active testers
        </Link>
        <Link className="btn btn-success d-block mb-3" to="admin/token">
          Generate bearer token
        </Link>
      </div>
    );
  }
}
